import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

/**
 * Stateless helpers describing the current device/app.
 * Separated because it has no Firebase dependency — it only reads AndroidBridge / userAgent.
 */
@Injectable({
  providedIn: 'root'
})
export class FirebaseDeviceInfoService {

  isTvWebView(): boolean {
    return !!(window as any).AndroidBridge;
  }

  getDeviceName(): string {
    // TV WebView mode: native app sets localStorage 'mode' = 1
    // AndroidBridge.getDeviceName() returns the device name entered at TV login screen
    const isTvWebView = localStorage.getItem('mode') === '1';
    if (isTvWebView) {
      return this.getAndroidDeviceName() || 'TV Device';
    }

    // Browser mode: parse from userAgent
    const ua = navigator.userAgent;
    let os = 'Unknown';
    let device = 'Desktop';

    if (/android/i.test(ua)) {
      os = 'Android';
      device = /tablet/i.test(ua) ? 'Tablet' : 'Mobile';
    } else if (/ipad/i.test(ua)) {
      os = 'iOS'; device = 'Tablet';
    } else if (/iphone/i.test(ua)) {
      os = 'iOS'; device = 'Mobile';
    } else if (/macintosh|mac os x/i.test(ua)) {
      os = 'macOS';
    } else if (/windows/i.test(ua)) {
      os = 'Windows';
    } else if (/linux/i.test(ua)) {
      os = 'Linux';
    }

    let browser = 'Browser';
    const chromeMatch = ua.match(/Chrome\/(\d+)/);
    const firefoxMatch = ua.match(/Firefox\/(\d+)/);
    const safariMatch = ua.match(/Version\/[\d.]+ .*Safari/);
    if (chromeMatch) browser = `Chrome ${chromeMatch[1]}`;
    else if (firefoxMatch) browser = `Firefox ${firefoxMatch[1]}`;
    else if (safariMatch) browser = 'Safari';

    return `${device} - ${os} (${browser})`;
  }

  getAndroidDeviceName(): string {
    const androidBridge = (window as any).AndroidBridge;
    if (!androidBridge || typeof androidBridge.getDeviceName !== 'function') {
      return '';
    }

    try {
      const deviceName = androidBridge.getDeviceName();
      return typeof deviceName === 'string' ? deviceName.trim() : '';
    } catch {
      return '';
    }
  }

  getAppVersion(): string {
    const androidBridge = (window as any).AndroidBridge;
    if (androidBridge && typeof androidBridge.getAppVersion === 'function') {
      return androidBridge.getAppVersion() || '';
    }
    return '';
  }

  getAndroidDeviceId(): string {
    const androidBridge = (window as any).AndroidBridge;
    if (!androidBridge || typeof androidBridge.getAndroidDeviceId !== 'function') {
      return '';
    }

    try {
      const deviceId = androidBridge.getAndroidDeviceId();
      return typeof deviceId === 'string' ? deviceId.trim() : '';
    } catch {
      return '';
    }
  }
  
  getWebViewVersion(): string {
    return environment.version;
  }

}
